'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Cloud1 from '@/images/cloud-1.png';
import Cloud2 from '@/images/cloud-2.png';
import Image from 'next/image';

export default function BackgroundRoad() {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);
  const [cloudPositions, setCloudPositions] = useState([
    { left: 0, speed: 0.05, top: 200, scale: 0.8 },
    { left: 800, speed: 0.02, top: 0, scale: 1 },
  ]);
  const [innerWidth, setInnerWidth] = useState(0);

  useEffect(() => {
    setPortalElement(document.getElementById('background-portal'));

    const windowResizeHandler = () => {
      setInnerWidth(window.innerWidth);
    };
    window.addEventListener('resize', windowResizeHandler);
    setInnerWidth(window.innerWidth);
    return () => window.removeEventListener('resize', windowResizeHandler);
  }, []);

  if (!portalElement || innerWidth < 1024) return null;

  return createPortal(
    <>
      <style jsx global>{`
        @keyframes floatCloud1 {
          0%,
          100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(20px);
          }
        }

        @keyframes floatCloud2 {
          0%,
          100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(-15px);
          }
        }

        .float-cloud-1 {
          animation: floatCloud1 8s ease-in-out infinite;
        }

        .float-cloud-2 {
          animation: floatCloud2 10s ease-in-out infinite;
        }
      `}</style>
      {/* 여러 개의 구름 */}
      <Image
        key={'cloud_1'}
        src={Cloud2}
        alt='cloud'
        width={250}
        height={250}
        quality={100}
        className='fixed opacity-40 z-10 transition-transform float-cloud-1'
        style={{
          right: 100,
          top: `${cloudPositions[0].top}px`,
          transform: `scale(${cloudPositions[0].scale})`,
        }}
      />
      <Image
        key={'cloud_2'}
        src={Cloud1}
        alt='cloud'
        width={250}
        height={250}
        quality={100}
        className='fixed opacity-40 z-10 transition-transform float-cloud-2'
        style={{
          left: 100,
          top: `${cloudPositions[1].top}px`,
          transform: `scale(${cloudPositions[1].scale})`,
        }}
      />
      <div className='fixed bottom-0 w-full h-120pxr -z-[1] opacity-80'>
        {/* 도로 배경 */}
        <div
          className='absolute bottom-0 w-full h-100pxr'
          style={{
            background: 'linear-gradient(180deg, #4a4a4a 0%, #2d2d2d 100%)',
          }}
        >
          {/* 도로 질감 */}
          <div
            className='absolute top-0 w-full h-full opacity-5'
            style={{
              backgroundImage: `
              radial-gradient(circle at 50% 50%, #fff 1%, transparent 1%)
            `,
              backgroundSize: '8px 8px',
            }}
          />

          {/* 차선들 */}
          <div className='relative w-full h-full'>
            {/* 첫 번째 차선 (위) */}
            <div
              className='absolute top-[33%] w-full h-4pxr'
              style={{
                background: `
                repeating-linear-gradient(
                  90deg,
                  #ffffff 0px,
                  #ffffff 40px,
                  transparent 40px,
                  transparent 60px
                )
              `,
              }}
            />

            {/* 두 번째 차선 (중앙) */}
            <div
              className='absolute top-[66%] w-full h-4pxr'
              style={{
                background: `
                repeating-linear-gradient(
                  90deg,
                  #ffffff 0px,
                  #ffffff 40px,
                  transparent 40px,
                  transparent 60px
                )
              `,
              }}
            />
          </div>

          {/* 도로 가장자리 */}
          <div className='absolute top-0 w-full h-2pxr bg-white opacity-50' />
          <div className='absolute bottom-0 w-full h-2pxr bg-white opacity-50' />
        </div>

        {/* 도로 그림자 */}
        <div
          className='absolute bottom-0 w-full h-20pxr'
          style={{
            background: 'linear-gradient(180deg, rgba(0,0,0,0.1) 0%, transparent 100%)',
          }}
        />
      </div>
    </>,
    portalElement,
  );
}
